'use client'

import React from 'react'
import Theme18OfferLink from './Theme18OfferLink'
import { ArrowRight, Tag, ExternalLink } from 'lucide-react'

const C = { PRIMARY: '#F8F246', SECONDARY: '#2CBBC3', BROWN: '#8C5826', BORDER: '#ffe0c2', TEXT: '#1a1a1a', MUTED: '#6b7280', ORANGE: '#FF9934' }

interface Props {
    unique_id: string
    outUrl: string
    merchantHref: string
    domain: string
    isCoupon: boolean
    couponCode?: string | null
    label?: string
    className?: string
}

const OfferCTAButton = ({ unique_id, outUrl, merchantHref, domain, isCoupon, couponCode, label = 'Get Deal', className = '' }: Props) => {
    const code = couponCode?.trim() ?? ''

    return (
        <Theme18OfferLink
            unique_id={unique_id}
            outUrl={outUrl}
            merchantHref={merchantHref}
            domain={domain}
            couponCode={code || undefined}
            customClass={`w-full block ${className}`}
        >
            <div className="w-full py-1.5 sm:py-2.5 px-2 sm:px-3 rounded-lg sm:rounded-xl text-center text-[10px] sm:text-xs font-black uppercase tracking-wider transition-all hover:scale-[1.02] active:scale-95 flex items-center justify-center gap-1 sm:gap-1.5 shadow-2xs whitespace-nowrap"
                style={isCoupon
                    ? { background: C.BROWN, color: '#ffffff' }
                    : { background: C.PRIMARY, color: C.BROWN }}>
                {isCoupon ? (
                    <>
                        <Tag size={11} style={{ color: C.PRIMARY }} className="flex-shrink-0 sm:w-3 sm:h-3" />
                        <span className="whitespace-nowrap">Get Code</span>
                        <ArrowRight size={11} style={{ color: C.PRIMARY }} className="flex-shrink-0 sm:w-3 sm:h-3" />
                    </>
                ) : (
                    <>
                        <span className="whitespace-nowrap">{label}</span>
                        <ArrowRight size={11} className="flex-shrink-0 sm:w-3 sm:h-3" />
                    </>
                )}
            </div>
        </Theme18OfferLink>
    )
}

export default OfferCTAButton
